<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#detail5_1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC13']['0'] }}
          </h3>
        </div>
        <div id="detail5_1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
              
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['60'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="">
              <div class="row">         
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['30'] }}</label>
                    <input type="text" id="desc_codrewd" name="desc_codrewd" class="form-control" readonly="readonly" v-model="detail.desc_codrewd" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['40'] }}</label>
                    <textarea id="desrewd1" name="desrewd1" class="form-control" maxlength="600" readonly="readonly">{{ detail.desrewd1 }}
                    </textarea>
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC13']['50'] }}</label>
                    <input type="text" id="numhmref" name="numhmref" class="form-control" readonly="readonly" v-model="detail.numhmref" />
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ buttonLabels['back'] }}</button>
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres33u-detail5',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'buttonLabels' ],
  computed: {
    descCodinput () {
      return this.detail.codinput + ' - ' + this.detail.desc_codinput
    },
    descCodempid () {
      return this.detail.codempid + ' - ' + this.detail.desc_codempid
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail5.vue?399fa31e